/** The login form prefills the username a signup or password reset just used (login_window.py). */
let prefill = "";
export const setLoginPrefill = (u: string) => { prefill = u; };
export const takeLoginPrefill = () => { const u = prefill; prefill = ""; return u; };
